import React from 'react'
import './header.css'
import people from '../../assets/people.png'
import ai from '../../assets/ai.png'

const Header = () => {
  return (
    <div className='omit__header section__padding' id='home'>
      <div className='omit__header-content'>
        <h1 className='gradient__text'>Software Development Company</h1>
        <p>
          Fuel your project with an expert team of industry-focused engineers
        </p>
        <div className='omit__header-content__input'>
          <input type='email' placeholder='Your email address' />
          <button type='button'>Get pricing</button>
        </div>
        <div className='omit__header-content__people'>
          <img src={people} alt='people' />
          <p>1000+ of outstanding projects in 10 years.</p>
        </div>
      </div>
      <div className='omit__header-image'>
        <img src={ai} alt='ai' />
      </div>
    </div>
  )
}

export default Header
